const columns= [
    {
        title: 'Message',
        dataIndex: 'changes',
    },
    {
        title: 'Update Date',
        dataIndex: 'createdDate',      
    },
  
   
];

export default columns;